module.exports = __webpack_public_path__ + "media/images/basket-c424195979a28e522fe896b235945311.svg";